"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.Market = void 0;
const flatbuffers = require("flatbuffers");
const outcome_js_1 = require("../../sportsbook/actual/outcome.js");
class Market {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsMarket(bb, obj) {
        return (obj || new Market()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsMarket(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new Market()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    id() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    specifiers(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    status() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readInt8(this.bb_pos + offset) : 1;
    }
    state() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readInt8(this.bb_pos + offset) : 1;
    }
    weight() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : 0;
    }
    provider() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.readInt8(this.bb_pos + offset) : 1;
    }
    favourite() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    outcomes(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? (obj || new outcome_js_1.Outcome()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    outcomesLength() {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    timestamp() {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? this.bb.readUint64(this.bb_pos + offset) : BigInt('0');
    }
    extendedSpecifiers(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 22);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startMarket(builder) {
        builder.startObject(10);
    }
    static addId(builder, id) {
        builder.addFieldInt32(0, id, 0);
    }
    static addSpecifiers(builder, specifiersOffset) {
        builder.addFieldOffset(1, specifiersOffset, 0);
    }
    static addStatus(builder, status) {
        builder.addFieldInt8(2, status, 1);
    }
    static addState(builder, state) {
        builder.addFieldInt8(3, state, 1);
    }
    static addWeight(builder, weight) {
        builder.addFieldInt8(4, weight, 0);
    }
    static addProvider(builder, provider) {
        builder.addFieldInt8(5, provider, 1);
    }
    static addFavourite(builder, favourite) {
        builder.addFieldInt8(6, +favourite, +false);
    }
    static addOutcomes(builder, outcomesOffset) {
        builder.addFieldOffset(7, outcomesOffset, 0);
    }
    static createOutcomesVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startOutcomesVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addTimestamp(builder, timestamp) {
        builder.addFieldInt64(8, timestamp, BigInt('0'));
    }
    static addExtendedSpecifiers(builder, extendedSpecifiersOffset) {
        builder.addFieldOffset(9, extendedSpecifiersOffset, 0);
    }
    static endMarket(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createMarket(builder, id, specifiersOffset, status, state, weight, provider, favourite, outcomesOffset, timestamp, extendedSpecifiersOffset) {
        Market.startMarket(builder);
        Market.addId(builder, id);
        Market.addSpecifiers(builder, specifiersOffset);
        Market.addStatus(builder, status);
        Market.addState(builder, state);
        Market.addWeight(builder, weight);
        Market.addProvider(builder, provider);
        Market.addFavourite(builder, favourite);
        Market.addOutcomes(builder, outcomesOffset);
        Market.addTimestamp(builder, timestamp);
        Market.addExtendedSpecifiers(builder, extendedSpecifiersOffset);
        return Market.endMarket(builder);
    }
}
exports.Market = Market;
